import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import './LeftSideBar.css';
import { themes, fonts } from '../themes/themes';
import MenuIcon from '../../assets/images/menu_icon.svg';
import DashboardIcon from '../../assets/images/dashboard_icon.svg';
import DashboardFilledIcon from '../../assets/images/dashboardFilled_icon.svg';
import EmployeeDetailfilled from '../../assets/images/employefilled_icon.svg';
import Iconfilled from '../../assets/images/iconfilled.svg';
import AnnouncefillIcon from '../../assets/images/announcefillIcon.svg';
import SuggestionFill from '../../assets/images/SuggestionFill.svg';
import EmployeeSuggestion from '../../assets/images/EmployeeSuggestion.svg';
import EmployeeDetail from '../../assets/images/employee_icon.svg';
import actionRequired from '../../assets/images/actionRequired.svg';
import actionRequiredFilled from '../../assets/images/actionRequiredFilled.svg';
import EmployeeDirectory from '../../assets/images/employee_directory_icon.svg';
import EmployeeAnnoucement from '../../assets/images/employee_annoucement_icon.svg';
import letter_generation from '../../assets/images/letter_generation.svg';
import letter_generation_filled from '../../assets/images/letter_generation_filled.svg';
import perfomance_icon_filled from '../../assets/images/perfomance_icon_filled.svg';
import performance_icon from '../../assets/images/performance_icon.svg';
import ToDoTask from '../../assets/images/to_do_task_icon.svg';
import ToDoTaskFilled from '../../assets/images/to_do_task_filled_icon.svg';
import AttendanceExecption from '../../assets/images/AttendanceException.svg';
import AttendanceExecptionFill from '../../assets/images/AttendanceExceptionFill.svg';

import { useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../infra/hooks';
import { setSideBar } from '../../infra/aggregates/sidebarSlice';
import { useTranslation } from 'react-i18next';
import { attendanceException } from '../../api/services/attendanceException';

const LeftSideBar = () => {
  const sidebar = useAppSelector((state) => state.sidebarSlice.sideBar);
  const isExceptionEnabled = useAppSelector((state) => state.exception.isEnabled);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  const trans = t;
  const configMenuList = useAppSelector(
    (state: any) => state.sideMenuSlice?.conigMenu,
  );
  const dynamicMenuNames = configMenuList.map((menu: any) => menu.name);
  return (
    <Box
      style={{
        width: sidebar ? '16.75em' : '6.25em',
        background: '#ffffff 0% 0% no-repeat padding-box',
        boxShadow: '0px 0px 0px 2px #00000029',
        display: 'flex',
        flexDirection: 'column',
        position: 'fixed',
        transition: 'width 0.5s',
        height: '100%',
        zIndex: '1',
        borderBottom: 'none',
        paddingTop: '1em',
      }}
    >
      {sidebar ? (
        <Box
          className={
            i18n.language == 'ar' ? 'side-bar-box_rtl' : 'side-bar-box'
          }
        >
          <Box
            style={{
              display: 'flex',
              flexDirection: 'row',
              cursor: 'pointer',
              width: '2.5em',
              height: '2.5em',
            }}
          >
            <img
              onClick={() => dispatch(setSideBar(!sidebar))}
              src={MenuIcon}
              className={i18n.language == 'ar' ? 'icons_bar_rtl' : 'icons_bar'}
            />
          </Box>
          <Box
            style={{
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <Box className="sidebar-icon">
              <Typography
                style={{
                  fontSize: '18px',
                  fontFamily: fonts.fontFamily,
                  color: themes.defaultScondary_blue,
                  letterSpacing: '1.6px',
                  fontWeight: 'bold',
                  textTransform: 'uppercase',
                }}
              >
                {trans('Main Menu')}
              </Typography>
            </Box>
            <Box
              className="sidebar-icon"
              onClick={() => {
                navigate({ pathname: '/dashboard' });
                dispatch(setSideBar(!sidebar));
              }}
            >
              <img
                src={DashboardIcon}
                className={
                  i18n.language == 'ar' ? 'icons_bar_rtl' : 'icons_bar'
                }
              />
              <Typography
                style={{
                  fontSize: fonts.title,
                  fontFamily: fonts.fontFamily,
                  color: themes.defaultIcon,
                  fontWeight: 'bold',
                }}
              >
                {trans('Dashboard')}
              </Typography>
            </Box>
            <Box
              //className="sidebar-icon"
              className="sidebar-icon"
              onClick={() => {
                dispatch(setSideBar(!sidebar));
                navigate({ pathname: '/employeePersonalDetails' });
              }}
            >
              <img
                src={EmployeeDetail}
                className={
                  i18n.language == 'ar' ? 'icons_bar_rtl' : 'icons_bar'
                }
              />
              <Typography
                style={{
                  fontSize: fonts.title,
                  fontFamily: fonts.fontFamily,
                  color: themes.defaultIcon,
                  fontWeight: 'bold',
                }}
              >
                {trans('My Profile')}
              </Typography>
            </Box>
            {
              !dynamicMenuNames?.includes('Employee Directory') && (
                <Box
                  className="sidebar-icon"
                  onClick={() => {
                    dispatch(setSideBar(!sidebar));
                    navigate({ pathname: '/employeedirectory' });
                  }}
                >
                  <img
                    src={EmployeeDirectory}
                    className={
                      i18n.language == 'ar' ? 'icons_bar_rtl' : 'icons_bar'
                    }
                  />
                  <Typography
                    style={{
                      fontSize: fonts.title,
                      fontFamily: fonts.fontFamily,
                      color: themes.defaultIcon,
                      fontWeight: 'bold',
                    }}
                  >
                    {trans('Employee Directory')}
                  </Typography>
                </Box>
              )
            }
            {/* <Box
              className="sidebar-icon"
              onClick={() => {
                dispatch(setSideBar(!sidebar));
                navigate({ pathname: '/toDoTask' });
              }}
            >
              <img
                src={ToDoTask}
                className={
                  i18n.language == 'ar' ? 'icons_bar_rtl' : 'icons_bar'
                }
              />
              <Typography
                style={{
                  fontSize: fonts.title,
                  fontFamily: fonts.fontFamily,
                  color: themes.defaultIcon,
                  fontWeight: 'bold',
                }}
              >
                {trans('To - Do Task')}
              </Typography>
            </Box> */}
            {
              !dynamicMenuNames?.includes('Announcement') && (
                <Box
                  className="sidebar-icon"
                  onClick={() => {
                    dispatch(setSideBar(!sidebar));
                    navigate({ pathname: '/employeeannouncement' });
                  }}
                >
                  <img
                    src={EmployeeAnnoucement}
                    className={
                      i18n.language == 'ar' ? 'icons_bar_rtl' : 'icons_bar'
                    }
                  />
                  <Typography
                    style={{
                      fontSize: fonts.title,
                      fontFamily: fonts.fontFamily,
                      color: themes.defaultIcon,
                      fontWeight: 'bold',
                    }}
                  >
                    {trans('Annoucement')}
                  </Typography>
                </Box>
              )
            }
            {
              !dynamicMenuNames?.includes('Suggestion') && (
                <Box
                  className="sidebar-icon"
                  onClick={() => {
                    dispatch(setSideBar(!sidebar));
                    navigate({ pathname: '/suggestion' });
                  }}
                >
                  <img
                    src={EmployeeSuggestion}
                    className={
                      i18n.language == 'ar' ? 'icons_bar_rtl' : 'icons_bar'
                    }
                  />
                  <Typography
                    style={{
                      fontSize: fonts.title,
                      fontFamily: fonts.fontFamily,
                      color: themes.defaultIcon,
                      fontWeight: 'bold',
                    }}
                  >
                    {trans('Suggestions')}
                  </Typography>
                </Box>
              )
            }
            {isExceptionEnabled && (
              <Box
                className="sidebar-icon"
                onClick={() => {
                  dispatch(setSideBar(!sidebar));
                  navigate({ pathname: '/attendanceException' });
                }}
              >
                <img
                  src={AttendanceExecption}
                  className={
                    i18n.language == 'ar' ? 'icons_bar_rtl' : 'icons_bar'
                  }
                />
                <Typography
                  style={{
                    fontSize: fonts.title,
                    fontFamily: fonts.fontFamily,
                    color: themes.defaultIcon,
                    fontWeight: 'bold',
                  }}
                >
                  {trans('Attendance Exception')}
                </Typography>
              </Box>
            )}
            {/* <Box
              className="sidebar-icon"
              onClick={() => {
                dispatch(setSideBar(!sidebar));
                navigate({ pathname: '/perfomance' });
              }}
            >
              <img
                src={EmployeeAnnoucement}
                className={
                  i18n.language == 'ar' ? 'icons_bar_rtl' : 'icons_bar'
                }
              />
              <Typography
                style={{
                  fontSize: fonts.title,
                  fontFamily: fonts.fontFamily,
                  color: themes.defaultIcon,
                  fontWeight: 'bold',
                }}
              >
                {trans('performance')}
              </Typography>
            </Box> */}
          </Box>
        </Box>
      ) : (
        <Box
          style={{
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
          }}
        >
          <Box
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
              width: '2.5em',
              height: '2.5em',
              paddingBottom: '2.25em',
              marginLeft: '1em',
              marginTop: '1em',
            }}
          >
            <img
              onClick={() => dispatch(setSideBar(!sidebar))}
              src={MenuIcon}
              style={{
                width: '1.75em',
                height: '1.75em',
              }}
            />
          </Box>
          <Box
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Box
              className="bar-icon"
              onClick={() => {
                dispatch(setSideBar(!sidebar));
              }}
            >
              <Typography
                style={{
                  fontSize: '28px',
                }}
              >
                --
              </Typography>
            </Box>
            <Box
              className={
                window.location.pathname == '/dashboard'
                  ? 'selected_bar-icon'
                  : 'bar-icon'
              }
              onClick={() => {
                navigate({ pathname: '/dashboard' });
              }}
            >
              <img
                src={
                  window.location.pathname == '/dashboard'
                    ? DashboardFilledIcon
                    : DashboardIcon
                }
                style={{
                  width: '1.5em',
                  height: '1.5em',
                  cursor: 'pointer',
                }}
              />
            </Box>
            <Box
              className={
                window.location.pathname.includes('employee') &&
                  window.location.pathname != '/dashboard' &&
                  window.location.pathname != '/employeedirectory' &&
                  window.location.pathname != '/employeeannouncement'
                  ? 'selected_bar-icon'
                  : 'bar-icon'
              }
            >
              <img
                onClick={() => {
                  navigate({ pathname: '/employeePersonalDetails' });
                }}
                src={
                  window.location.pathname.includes('employee') &&
                    window.location.pathname != '/dashboard' &&
                    window.location.pathname != '/employeedirectory' &&
                    window.location.pathname != '/employeeannouncement'
                    ? EmployeeDetailfilled
                    : EmployeeDetail
                }
                style={{
                  width: '1.5em',
                  height: '1.5em',
                  cursor: 'pointer',
                }}
              />
            </Box>
            <Box
              className={
                window.location.pathname == '/actionRequired'
                  ? 'selected_bar-icon'
                  : 'bar-icon'
              }
            >
              <img
                onClick={() => {
                  navigate({ pathname: '/actionRequired' });
                }}
                src={
                  window.location.pathname == '/actionRequired'
                    ? actionRequiredFilled
                    : actionRequired
                }
                style={{
                  width: '1.5em',
                  height: '1.5em',
                  cursor: 'pointer',
                }}
              />
            </Box>
            {/* <Box
              className={
                window.location.pathname == '/toDoTask'
                  ? 'selected_bar-icon'
                  : 'bar-icon'
              }
            >
              <img
                onClick={() => {
                  navigate({ pathname: '/toDoTask' });
                }}
                src={
                  window.location.pathname == '/toDoTask'
                    ? ToDoTaskFilled
                    : ToDoTask
                }
                style={{
                  width: '1.5em',
                  height: '1.5em',
                  cursor: 'pointer',
                }}
              />
            </Box> */}
            {
              !dynamicMenuNames?.includes('Employee Directory') && (
                <Box
                  className={
                    window.location.pathname == '/employeedirectory'
                      ? 'selected_bar-icon'
                      : 'bar-icon'
                  }
                >
                  <img
                    onClick={() => {
                      navigate({ pathname: '/employeedirectory' });
                    }}
                    src={
                      window.location.pathname == '/employeedirectory'
                        ? Iconfilled
                        : EmployeeDirectory
                    }
                    style={{
                      width: '1.5em',
                      height: '1.5em',
                    }}
                  />
                </Box>
              )
            }
            {
              !dynamicMenuNames?.includes('Announcement') && (
                <Box
                  className={
                    window.location.pathname == '/employeeannouncement'
                      ? 'selected_bar-icon'
                      : 'bar-icon'
                  }
                >
                  <img
                    onClick={() => {
                      navigate({ pathname: '/employeeannouncement' });
                    }}
                    src={
                      window.location.pathname == '/employeeannouncement'
                        ? AnnouncefillIcon
                        : EmployeeAnnoucement
                    }
                    style={{
                      width: '1.5em',
                      height: '1.5em',
                    }}
                  />
                </Box>
              )
            }
            {
              !dynamicMenuNames?.includes('Suggestion') && (
                <Box
                  className={
                    window.location.pathname == '/suggestion'
                      ? 'selected_bar-icon'
                      : 'bar-icon'
                  }
                >
                  <img
                    onClick={() => {
                      navigate({ pathname: '/suggestion' });
                    }}
                    src={
                      window.location.pathname == '/suggestion'
                        ? SuggestionFill
                        : EmployeeSuggestion
                    }
                    style={{
                      width: '1.5em',
                      height: '1.5em',
                    }}
                  />
                </Box>
              )
            }
            {isExceptionEnabled && (
              <Box
                className={
                  window.location.pathname == '/attendanceException'
                    ? 'selected_bar-icon'
                    : 'bar-icon'
                }
              >
                <img
                  onClick={() => {
                    navigate({ pathname: '/attendanceException' });
                  }}
                  src={
                    window.location.pathname == '/attendanceException'
                      ? AttendanceExecptionFill
                      : AttendanceExecption
                  }
                  style={{
                    width: '1.5em',
                    height: '1.5em',
                  }}
                />
              </Box>
            )}
            {/* <Box
              className={
                window.location.pathname == '/empLetterGeneration'
                  ? 'selected_bar-icon'
                  : 'bar-icon'
              }
            >
              <img
                onClick={() => {
                  navigate({ pathname: '/empLetterGeneration' });
                }}
                src={
                  window.location.pathname == '/empLetterGeneration'
                    ? letter_generation_filled
                    : letter_generation
                }
                style={{
                  width: '1.5em',
                  height: '1.5em',
                }}
              />
            </Box> */}
            {/* <Box
              className={
                window.location.pathname == '/perfomance'
                  ? 'selected_bar-icon'
                  : 'bar-icon'
              }
            >
              <img
                onClick={() => {
                  navigate({ pathname: '/perfomance' });
                }}
                src={
                  window.location.pathname == '/perfomance'
                    ? perfomance_icon_filled
                    : performance_icon
                }
                style={{
                  width: '1.5em',
                  height: '1.5em',
                }}
              />
            </Box> */}
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default LeftSideBar;
